<template>
  <div class="join-us">
    <div class="join-content padding-main mobile-padding">
      <el-row>
        <el-col :xs="24"
                :sm="24"
                :md="8">
          <div class="join-title-en">Join us</div>
          <div class="join-title">{{ $t('joinUs.joinUs') }}</div>
          <div class="join-tip">{{ $t('common.yyAddress') }}</div>
          <div class="join-tip"
               style="margin-bottom: 9.33vw;">{{ $t('common.yyHrEmail') }}</div>
        </el-col>
        <el-col :xs="24"
                :sm="24"
                :md="16"
                class="join-image"
                style="text-align: right;">
          <div class="image-flex">
            <el-image src="/svg/join_us.svg"
                      fit="cover" />
          </div>
        </el-col>
      </el-row>
    </div>
    <!--     <div class="join-tabs padding-main mobile-padding">
      <div class="tabs-name">{{ $t('joinUs.employerPosition') }}</div>
      <el-tabs v-model="activeName"
               @tab-click="handleClick">
        <el-tab-pane v-for="item in tabList"
                     :key="item.id"
                     :label="item.name"
                     :name="item.id">
          <template v-if="!item.id">
            <div v-for="(fItem,index) in jobList"
                 :key="index"
                 class="job-item">
              <div class="job-name">
                <span>{{ fItem.title }}</span>
                <el-button type="warning"
                           round
                           size="small"
                           @click="joinUs">{{ $t('joinUs.delivery') }}</el-button>
              </div>
              <div class="company">{{ $t('common.yyName') }}</div>
              <div class="salary">{{ fItem.salary }}</div>
              <div class="address">{{ $t('common.yyAddress') }}</div>
              <el-breadcrumb separator="|">
                <el-breadcrumb-item>{{ fItem.city }}</el-breadcrumb-item>
                <el-breadcrumb-item>{{ fItem.education }}</el-breadcrumb-item>
                <el-breadcrumb-item>{{ fItem.years }}</el-breadcrumb-item>
              </el-breadcrumb>
              <div class="detail"
                   v-html="fItem.details" />
            </div>
          </template>
          <template v-else>
            <div class="job-item">
              <div class="job-name">
                <span>{{ jobData.title }}</span>
                <el-button type="warning"
                           round
                           size="small"
                           @click="joinUs">{{ $t('joinUs.delivery') }}</el-button>
              </div>
              <div class="company">{{ $t('common.yyName') }}</div>
              <div class="salary">{{ jobData.salary }}</div>
              <div class="address">{{ $t('common.yyAddress') }}</div>
              <el-breadcrumb separator="|">
                <el-breadcrumb-item>{{ jobData.city }}</el-breadcrumb-item>
                <el-breadcrumb-item>{{ jobData.education }}</el-breadcrumb-item>
                <el-breadcrumb-item>{{ jobData.years }}</el-breadcrumb-item>
              </el-breadcrumb>
              <div class="detail"
                   v-html="jobData.details" />
            </div>
          </template>
        </el-tab-pane>
      </el-tabs>
    </div> -->
    <!-- <div class="join-welfare padding-main mobile-padding">
      <div class="welfare-title">{{ $t('joinUs.socialBenefits') }}</div>
      <el-row>
        <el-col v-for="(item,index) in welfareList"
                :xs="24"
                :sm="24"
                :md="index%2==0?13:11"
                :key="index">
          <div class="welfare-item">
            <div class="item-name">{{ item.name }}</div>
            <div class="item-describe">{{ item.describe }}</div>
          </div>
        </el-col>
      </el-row>
    </div> -->
  </div>
</template>

<script>
import { joinUsApi } from '@/api/homeApi'
import { joinUsObj } from '@/const/crud/list'

export default {
  name: 'JoinUs',
  data() {
    return {
      jobList: [],
      jobData: {},
      activeName: '',
      tabList: joinUsObj.tabList,
      welfareList: joinUsObj.welfareList
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    async fetchData() {
      try {
        const res = await joinUsApi.fetchJobList({
          type: 0
        })
        this.jobList = res.data.data
      } catch (err) {
        console.error(err)
      }
    },
    handleClick(e) {
      this.jobData = {}
      const obj = this.jobList.find(item => item.id == e.name)
      if (obj) {
        this.jobData = obj
      }
    },
    joinUs() {
      this.$alert('请将邮件投递到公司邮箱</br>邮箱地址：hr@ynye.com</br>我们期待您的加入！', '招兵买马', {
        confirmButtonText: '关闭',
        dangerouslyUseHTMLString: true,
        center: true,
        lockScroll: false
      })
    }
  }

}
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';
@import '@/styles/mixin.scss';
$padding: 18.75vw;

.padding-main {
  padding: 1.77vw $padding;
}

@mixin title {
  font-size: 26px;
  font-weight: bold;
}

.image-flex {
  height: 100%;
  @include wrap-flex;
}

.el-row,
.el-col {
  height: 100%;
}

.join-us {
  .join-content {
    background-color: $bgColor;
    color: #3f3e3e;
    .join-title-en {
      font-size: 34px;
      margin-top: 7.29vw;
      margin-bottom: 1.04vw;
    }
    .join-title {
      font-size: 44px;
      font-weight: bold;
      margin-bottom: 0.52vw;
    }
    .join-tip {
      margin-bottom: 0.52vw;
      font-size: 18px;
    }
  }
  .join-tabs {
    padding-top: 2.6vw;
    padding-bottom: 3.125vw;
    /deep/.el-tabs__item {
      font-size: 16px;
    }
    .tabs-name {
      font-size: 26px;
      font-weight: bold;
      margin-bottom: 1.02vw;
    }
    .job-item {
      padding-top: 3.125vw;
      .job-name {
        font-size: 26px;
        font-weight: bold;
        margin-bottom: 0.52vw;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .el-button {
          width: 7.3vw;
          min-width: 80px;
        }
      }
      .salary {
        font-size: 28px;
        margin: 1.02vw 0;
        color: #ffa30c;
      }
      .address {
        margin-bottom: 0.625vw;
      }
      .el-breadcrumb {
        font-size: 16px;
        /deep/ .el-breadcrumb__separator {
          vertical-align: text-top;
        }
      }
      .detail {
        margin-top: 2.08vw;
        border-top: 1px solid #d8d8d8;
        padding-top: 2.08vw;
      }
    }
  }
  .join-welfare {
    padding-top: 2.6vw;
    background-color: $bgColor;
    // height: 34.375vw;
    .welfare-title {
      font-size: 26px;
      font-weight: bold;
      color: #e99203;
      margin-bottom: 1.56vw;
    }
    .welfare-item {
      // height: 6vw;
      margin-bottom: 2.08vw;
      .item-name {
        font-size: 22px;
        font-weight: bold;
        margin-bottom: 12px;
        color: #e99203;
        &::before {
          content: '';
          width: 4px;
          height: 24px;
          display: inline-block;
          margin-right: 12px;
          background-color: #e99203;
          vertical-align: text-bottom;
        }
      }
      .item-describe {
        font-size: 16px;
      }
    }
  }
}
@media screen and (min-width: 992px) and (max-width: 1440px) {
  .welfare-item {
    .item-describe {
      font-size: 14px !important;
    }
  }
}
@media screen and (max-width: 992px) {
  .el-col {
    height: auto;
  }
  .mobile-padding {
    height: auto !important;
    padding: 5.33vw $mobilePadding !important;
  }
  .join-us {
    .join-content {
      text-align: center;
      height: 106.67vw !important;
      padding: 5.33vw $mobilePadding 0 !important;
      .join-title-en {
        font-size: 6.4vw;
        margin-bottom: 1.33vw;
      }
      .join-title {
        font-size: 4.8vw;
        margin-bottom: 1.33vw;
      }
      .join-tip {
        font-size: $mobileFontSize;
        margin-bottom: 1.33vw;
      }
      .join-image {
        text-align: center !important;
        .el-image {
          width: 58.67vw;
        }
      }
    }
    .join-tabs {
      .tabs-name {
        font-size: 4.27vw;
      }
      /deep/.el-tabs__item {
        font-size: $mobileFontSize;
      }
      /deep/ .el-tabs__nav-wrap {
        &::after {
          height: 0px;
        }
      }
      .job-item {
        .job-name {
          font-size: 4.27vw;
          margin-bottom: 4.27vw;
        }
        .company {
          font-size: $mobileFontSize;
          margin-bottom: 8vw;
        }
        .salary {
          font-size: 5.33vw;
          margin-bottom: 4.27vw;
        }
        .address {
          font-size: $mobileFontSize;
          margin-bottom: 4.27vw;
        }
        .el-breadcrumb {
          font-size: $mobileFontSize;
          /deep/ .el-breadcrumb__separator {
            vertical-align: text-top;
          }
        }
        .detail {
          margin-top: 10.76vw;
          border-top: 1px solid #d8d8d8;
          padding-top: 10.76vw;
        }
      }
    }
    .join-welfare {
      .welfare-title {
        font-size: 4.27vw;
        margin-bottom: 8vw;
      }
      .welfare-item {
        height: auto;
        margin-bottom: 5.87vw;
        .item-name {
          font-size: $mobileFontSize;
          &::before {
            height: $mobileFontSize;
            // vertical-align: -2px;
          }
        }
        .item-describe {
          font-size: $mobileFontSize;
        }
      }
    }
  }
}
</style>
